export enum PermissaoPerfil {
  MASTER_DN = 'Master DN - SDG',
}
